export default __webpack_public_path__ + "static/media/roundedCross.0a58cf79.svg";